import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Injectable()
export class vovSharedService {
    public onUserUpdation = new Subject<any>();
    // public onUserSessionExpire = new Subject<any>();
    
    constructor(
        private httpClient: HttpClient
    ) { }

    fetchAllReasons(): Observable<any> {
        return this.httpClient.get('api/reason/fetchAllParkingReasons', {})
            .pipe(
                map((body: any) => {
                    if (body.status === 200) {
                        throw new Error(body.response.message);
                    } else {
                        return body;
                    }
                })
            );
    }
    fetchAllStreets(): Observable<any> {
        return this.httpClient.get('api/address/fetchAllStreets').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    fetchAllViolationActions(): Observable<any> {
        return this.httpClient.get('api/enforcement/fetchAllViolationActions').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }


    fetchAllEnforcement(data): Observable<any> {
        return this.httpClient.get('api/enforcement/fetchAllEnforcement', { params: data }).pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    fetchAllStates(): Observable<any> {
        return this.httpClient.get('api/state/fetchAllStates').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    getStreetNumbersByStreetId(streetId): Observable<any> {
        let params: any = {};
        params.streetId = streetId;
        return this.httpClient.get('api/address/getStreetNumbersByStreetId',
            { params })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            )
    }

    resetPassword(data): Observable<any> {
        return this.httpClient.post('api/user/resetPassword',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    passwordEmailConfirmation(data): Observable<any> {
        return this.httpClient.post('api/user/confirmEmail',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    checkisPasswordReset(data): Observable<any> {
        return this.httpClient.get(`api/user/passwordAlreadyReset/${data}`)
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    fetchAllRoles(): Observable<any> {
        return this.httpClient.get('api/role/fetchAllRoles').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    customFieldValidator(control: FormControl) {
        let pattern = /^(?!\d+$)\w+\S+/;
        let value = `${control.value}`;
    
        if (value.match(pattern)) {
          return null;
        } else {
          return {
            patternValidation: true
          }
        }
      }

      customFieldValidationForDate(control: FormControl) {
        let pattern = /^\d{2}([./-])\d{2}\1\d{4}$/;
        let value = `${control.value}`;
    
        if (value.match(pattern)) {
          return null;
        } else {
          return {
            patternValidation: true
          }
        }
      }

}